<section #scrollArea>
  <div class="container">
    @if (!isLoading && voicemailSettings) {
      @switch (selectedPage) {
        @case ('Main') {
          <app-settings-voicemail-main-page
            #voicemailMainPageComponent
            [settings]="voicemailSettings"
            [greetings]="greetings"
            [recordedName]="recordedName"
            [playingAudioId]="playingAudioId"
            [contacts]="(this.contactService.data$ | async) ?? []"
            (playClicked)="playAudio($event)"
            (stopClicked)="stopAudio()"
            (saveSettings)="saveSettings($event)"
            (cancelClick)="voicemailSettingsSaved.emit(false)"
            (selectedPageChanged)="setSelectedPage($event)"
            (addNewGreetingClicked)="goToManageGreetingPage(AudioType.greeting)"
            (manageRecorderNameClicked)="onManageRecorderNameClicked()"
            (greetingEditClicked)="onGreetingEditClicked($event)"
            (greetingDownloadClicked)="downloadAudioFile($event)"
            (greetingDeleteClicked)="onAudioDeleteClicked($event)"
            (isSaveButtonEnabledChange)="isSaveButtonEnabledChanged($event)">
          </app-settings-voicemail-main-page>
        }
        @case ('ManageGreeting') {
          <app-settings-voicemail-manage-greeting
            #voicemailManageGreetingComponent
            [audioItem]="itemToEdit"
            [audioType]="editAudioType"
            [ttsLanguages]="ttsLanguages"
            [ttsVoices]="voicesOfSelectedLanguage"
            [index]="indexToEdit"
            [isRecording]="voiceMessageRecorder.isRecording"
            [recordingSeconds]="recordingSeconds"
            [recordedFile]="recordedFile"
            [recordingTrack]="track"
            [playingAudioId]="playingAudioId"
            [user]="currentUser"
            [audio]="audioToEdit"
            (stopPreview)="stopAudio()"
            (selectedPageChanged)="setSelectedPage($event)"
            (playPreviewTtsClicked)="playTtsPreview($event)"
            (selectedTTSLanguageChanged)="getVoicesOfLanguage($event)"
            (saveClickedTTS)="uploadTTS($event)"
            (saveClickedFile)="uploadAudioFile($event)"
            (saveClickedRecord)="uploadAudioFile($event)"
            (recorderClicked)="toggleRecording($event)"
            (deleteAudioClicked)="audioToEdit = null"
            (togglePlayRecordedFile)="playRecordedFile()"
            (togglePlayAudio)="playAudioToEdit()"
            (isValidChange)="isSaveButtonEnabledChanged($event)">
          </app-settings-voicemail-manage-greeting>
        }
        @case ('Pin') {
          <app-settings-voicemail-change-pin
            #voicemailChangePinComponent
            (submitForm)="updatePin($event)"
            (selectedPageChanged)="setSelectedPage($event)"
            (validChange)="isSaveButtonEnabledChanged($event)">
          </app-settings-voicemail-change-pin>
        }
      }
    } @else {
      <div class="w-100 h-100 flex justify-content-center align-items-center">
        <mat-spinner diameter="24"></mat-spinner>
      </div>
    }
  </div>
  @if (editingDisabled) {
    <div
      class="grey-mask"
      #greyMask></div>
  }
</section>

<div class="flex justify-content-end align-center bottom-bar">
  <button
    (click)="handleCancelButtonClick(selectedPage)"
    class="cancel-button"
    id="cancel-button"
    mat-button
    type="button"
    appBrandingColor
    [brandingField]="BrandingField.FieldColorFontIconsListAreaItems"
    styleType="color">
    {{ 'VOICE_MAIL_PREFERENCES.CANCEL' | translate }}
  </button>
  <button
    color="primary"
    mat-raised-button
    class="m-l-12 save-button"
    type="button"
    [disabled]="!this.saveButtonEnabled || this.isSaving"
    (click)="handleSavePreferencesClick(selectedPage)"
    appBrandingColor
    [brandingField]="BrandingField.FieldColorFontIconsListAreaItems">
    @if (!isSaving) {
      <span>{{ 'VOICE_MAIL_PREFERENCES.SAVE' | translate }}</span>
    } @else {
      <mat-spinner
        class="processing-spinner"
        color="accent"></mat-spinner>
    }
  </button>
</div>
